import { createContext } from "react";
import usePageLogin from "containers/PageLogin/usePageLogin";
//
// Create the context
//
const AuthContext = createContext();

//
const AuthProvider = ({ children }) => {
  const {
    loading,
    setLoading,
    showOtpDiv,
    setShowOtpDiv,
    profile,
    setProfile,
    set,
    Reset,
    number,
    setPhone,
    getOTP,
    getUserProfile,
    setOtp,
    otp,
    useRemoveDataAndNavigate,
    got,
    setGot,
    show,
    onCloseModalQuickView
  } = usePageLogin();

  return (
    <AuthContext.Provider
      value={{
        loading,
        setLoading,
        showOtpDiv,
        setShowOtpDiv,
        profile,
        setProfile,
        set,
        Reset,
        number,
        setPhone,
        getOTP,
        getUserProfile,
        setOtp,
        otp,
        useRemoveDataAndNavigate,
        got,
        setGot,
        show,
        onCloseModalQuickView
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
